import React, { useContext, Suspense } from 'react';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { string, func, number } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import './styles/global-styles.scss';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

const browseBatchedDomains = {
  search: [
    'appliedDimensions',
    'relatedResults',
    'orangeGraph',
    'dimensions',
    'templates'
  ]
};

export const App = ({

  pipTimeout,
  prefetchPip,
  productPodHoverDelay
}) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path={routes.browse.path}>
          <routes.browse.component
            pageType="browse"
            prefetchPip={prefetchPip}
            productPodHoverDelay={productPodHoverDelay}
          />
        </Route>
        <Route path={routes.search.path}>
          <routes.search.component
            pageType="search"
            prefetchPip={prefetchPip}
            productPodHoverDelay={productPodHoverDelay}
          />
        </Route>
        <Route exact path={routes.pep.path}>
          {channel === 'mobile' && <routes.pepMobile.component />}
          {channel !== 'mobile' && <routes.pep.component />}
        </Route>
        <Route exact path={routes.product.path}>
          <routes.product.component pipTimeout={pipTimeout} />
        </Route>
        <Route exact path={routes.compare.path}>
          <routes.compare.component />
        </Route>
        <Route exact path={routes.home.path}>
          <routes.home.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {
  pipTimeout: string,
  prefetchPip: string,
  productPodHoverDelay: number,
};

App.defaultProps = {
  pipTimeout: null,
  prefetchPip: null,
  productPodHoverDelay: 500
};
